module.exports = __webpack_public_path__ + "static/media/cert_148.8a93c650.jpg";